import { MessageCircle } from "lucide-react";

export function WhatsAppFab() {
  return (
    <a
      href="https://wa.me/573163201208?text=Hola%20PRICO%2C%20quiero%20más%20información"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea por WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full animate-pulse-ring" />
      <span className="relative grid place-items-center size-14 rounded-full bg-[#25D366] text-white shadow-glow group-hover:scale-110 transition">
        <MessageCircle className="size-6" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-ink text-primary-foreground text-xs font-medium px-3 py-1.5 opacity-0 group-hover:opacity-100 transition" style={{ background: "var(--ink)", color: "white" }}>
        ¿Hablamos?
      </span>
    </a>
  );
}
